export const PROPERTIES_ROOMS_MAP: { [key: string]: string } = {
  rooms_studio: 'Studio',
  rooms_1: '1 BR',
  rooms_2: '2 BR',
  rooms_3: '3 BR',
  rooms_4: '4 BR',
  rooms_5: '5 BR',
  rooms_6: '6 BR',
  rooms_7: '7 BR',
}

export const BEDROOMS_ITEMS = [
  {
    value: null,
    text: 'Any',
  },
  {
    value: 0,
    text: 'Studio',
  },
  {
    value: 1,
    text: '1',
  },
  {
    value: 2,
    text: '2',
  },
  {
    value: 3,
    text: '3',
  },
  {
    value: 4,
    text: '4+',
  },
]

export enum PROPERTY_TYPE {
  APARTMENT = 'apartment',
  VILLA = 'villa',
  TOWNHOUSE = 'townhouse',
  STUDIO = 'studio',
}

export enum PROPERTY_STATUS {
  COMPLETED = 'Completed',
  OFF_PLAN = 'Off-plan',
  UNDER_CONSTRUCTION = 'Under-construction',
}

export enum PAYMENT_STATUS {
  IN_PROGRESS = 'In Progress',
  COMPLETED = 'Completed',
  PENDING = 'Pending',
}

export const SALE_STATUSES = {
  ANNOUNCEMENT: 'announcement',
  LAUNCH: 'launch',
  ON_SALE: 'on_sale',
  PENDING: 'pending',
  PRE_SALE: 'presale(_e_o_i)',
  SOLD_OUT: 'sold_out',
}

export enum SaleStatusLabel {
  ON_SALE = 'On Sale',
  PRESALE_EOI = 'Presale (EOI)',
  OFF_PLAN = 'Off Plan',
}

export const SALE_STATUS_DISPLAY_MAP: Record<string, string> = {
  [SaleStatusLabel.ON_SALE]: SaleStatusLabel.PRESALE_EOI,
}

export const initialFilters = {
  query: '',
  orderBy: '',
  sortedBy: '',
  status: '',
  createdAt: [],
  membershipDate: [],
  refundStatus: '',
  refundDate: [],
  role: '',
}
